module.exports = __webpack_public_path__ + "static/media/rating-5.ef02737c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/rating-5.svg
// module id = 1094
// module chunks = 0